<template>
  <div>
    <div v-if="!carrinhos.length" align="center" class="headline">
      O carrinho está vazio.
    </div>
    <v-card class="mt-5 card-shadow"
            v-for="fornecedor in fornecedores"
            :key="fornecedor.id">
      <v-card-text>
        <px-listagem-carrinho-fornecedores
                :finalizar="finalizar"
                :fornecedor="fornecedor"
                :disable-actions="disableActions"
                :remover-carrinho="removerCarrinho"
                :remover-produto="removerProduto"/>
        <v-row class="text--primary">
          <v-col cols="6">
            <span v-if="freteGratis(fornecedor).oferta">
              Oferta frete grátis a partir de: {{ freteGratis(fornecedor).valor | currency }}
            </span>
          </v-col>
          <v-col cols="6" class="d-flex align-right justify-end body-1">
            <span class="orange--text text--darken-4 font-weight-bold">
              Total: {{ totalFornecedor(fornecedor).totalConvertido | currency('R$', casaDecimal) }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  groupBy, forEach, first, sumBy, orderBy,
} from 'lodash';
import { CasaDecimalUtils, DetalheFornecedorUtils } from 'px-components';
import { totalFornecedor } from './calculo-carrinho.service';
import { getValorFreteGratis } from '../finalizacao/finalizacao-utils';
import ListagemCarrinhoFornecedores from './ListagemCarrinhoFornecedores.vue';

export default {
  props: {
    carrinhos: Array,
    disableActions: {
      type: Boolean,
      default: false,
    },
    removerCarrinho: {
      type: Function,
      required: false,
      default: () => {
      },
    },
    removerProduto: {
      type: Function,
      required: false,
      default: () => {
      },
    },
    finalizar: {
      type: Function,
      required: false,
      default: () => {
      },
    },
  },
  data() {
    return {
      fornecedores: [],
    };
  },
  computed: {
    freteGratis() {
      return fornecedor => getValorFreteGratis(fornecedor.carrinhos);
    },
    casaDecimal() {
      const mappedProdutos = this.carrinhos.flatMap(carrinho => carrinho
        .produtos.map(
          produto => produto.respostaCotacaoProduto.cotacaoProduto.produto,
        ));
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    totalFornecedor() {
      return fornecedor => totalFornecedor(fornecedor);
    },
  },
  methods: {
    agruparFornecedores(data) {
      this.fornecedores = [];
      if (!data) {
        return;
      }
      const temp = groupBy(data, i => `${i.respostaCotacao.fornecedor.id}-${i.comprador.id}`);
      forEach(temp, this.addFornecedor);
      this.fornecedores = orderBy(this.fornecedores, ['fornecedor.nome'], ['asc']);
    },
    orderProdutosCarrinhos(carrinhos) {
      return carrinhos.map(
        carrinho => ({
          ...carrinho,
          produtos: orderBy(carrinho.produtos, ['respostaCotacaoProduto.cotacaoProduto.id'], ['asc']),
        }),
      );
    },
    addFornecedor(v) {
      const cotacao = { ...first(v).respostaCotacao.cotacao };
      this.fornecedores.push({
        comprador: first(v).comprador,
        fornecedor: this.buildFornecedor(first(v).respostaCotacao.fornecedor, cotacao),
        carrinhos: this.orderProdutosCarrinhos(v),
        totalTransporte: sumBy(v, 'respostaCotacao.frete.totalTransporte'),
        totalTransporteConvertido: sumBy(v, 'respostaCotacao.frete.totalTransporteConvertido'),
      });
    },
    buildFornecedor(fornecedor, cotacao) {
      const { detalhesFornecedores } = cotacao;
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);
      return {
        ...fornecedor,
        codigoInterno: detalhe.codigoInterno,
        pessoa: {
          ...fornecedor.pessoa,
          nome: detalhe.nome || fornecedor.pessoa.nome,
        },
      };
    },
  },
  created() {
    if (this.carrinhos) {
      this.agruparFornecedores(this.carrinhos);
    }
  },
  watch: {
    carrinhos(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.agruparFornecedores(this.carrinhos);
    },
  },
  components: { pxListagemCarrinhoFornecedores: ListagemCarrinhoFornecedores },
};
</script>
